/* eslint-disable import/prefer-default-export */
export const clearQueryString = (router) => {
  const queryMessageId = router.query.messageid

  // Need this condition; Calling router.push indiscriminately will cause the chat to re-render unnecessarily, making it jumpy
  if (queryMessageId) {
    router.push('/project/[projectSlug]', router.asPath.split('?')[0], { shallow: true })
  }
}
